import React from 'react';

import Block from 'ui/block';
import PageCoverSection from 'components/page-cover';
import Section from 'components/Section';
import SiteHead from 'components/Head';

import COVER_PHOTO from 'img/cover-tech.jpg';

import PYTHON_LOGO from './img/python.svg';
import REDIS_LOGO from './img/redis.svg';
import JAVASCRIPT_LOGO from './img/javascript.svg';
import REACT_LOGO from './img/react.svg';
import POSTGRESQL_LOGO from './img/postgresql.svg';
import GRAPHQL_LOGO from './img/graphql.svg';
import DOCKER_LOGO from './img/docker.svg';
import FLASK_LOGO from './img/flask.svg';
// import Icon from 'svg-react-loader?name=Icon!./img/Python-logo-notext.svg';



function PageCover() {
    return <PageCoverSection image={COVER_PHOTO} slantBottom="up">
        <Block style={{textAlign: 'center'}}>
            <h1 style={{fontSize:'3em',fontWeight:'400'}}>
                Technology we like
            </h1>
            <p style={{fontSize: '1.6em'}}>
                Most of the software we build is cloud-based and offers
                a web interface.<br/>
                This makes it accessible anytime, anywhere, from
                any connected device.
            </p>
        </Block>
    </PageCoverSection>;
};


function TechItem({icon, name}) {
    return <div style={{display: 'inline-block', maxWidth: '400px', margin: '10px'}}>
        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
            <div>
                <img src={icon} alt="" style={{height: '100px'}} />
            </div>
            <div style={{flex: '1', marginLeft: '10px'}}>
                <h2>{name}</h2>
            </div>
        </div>
    </div>;
}


const IndexPage = () => (
    <div>

        <SiteHead title="Technology" image={COVER_PHOTO} />

        <PageCover/>

        <Section>
            <Block style={{fontSize: '1.6em', textAlign: 'center'}}>
                <p>
                    Our usual tech stack employs various components, including:
                </p>
            </Block>
            <Block style={{textAlign: 'center'}}>

                <TechItem name="Python" icon={PYTHON_LOGO} />
                <TechItem name="Javascript" icon={JAVASCRIPT_LOGO} />
                <TechItem name="Flask" icon={FLASK_LOGO} />
                <TechItem name="React" icon={REACT_LOGO} />
                <TechItem name="GraphQL" icon={GRAPHQL_LOGO} />
                <TechItem name="Postgresql" icon={POSTGRESQL_LOGO} />
                <TechItem name="Redis" icon={REDIS_LOGO} />
                <TechItem name="Docker" icon={DOCKER_LOGO} />

            </Block>
        </Section>

    </div>
);

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/technology/index.js